interface SectionHeadingProps {
  index?: string;
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({
  index,
  eyebrow,
  title,
  desc,
  align = 'left',
}: SectionHeadingProps) {
  const isCenter = align === 'center';

  return (
    <div className={isCenter ? 'text-center max-w-2xl mx-auto' : 'max-w-2xl'}>
      {(eyebrow || index) && (
        <div
          className={`flex items-center gap-3 mb-4 ${
            isCenter ? 'justify-center' : ''
          }`}
        >
          {index && (
            <span className="font-heading text-sm font-bold text-primary-600">
              {index}
            </span>
          )}
          <span className="w-8 h-px bg-primary-300" />
          {eyebrow && (
            <span className="font-label text-xs tracking-[0.28em] text-foreground-500 uppercase">
              {eyebrow}
            </span>
          )}
        </div>
      )}
      <h2 className="font-heading font-bold text-foreground-950 text-2xl md:text-3xl lg:text-4xl leading-snug">
        {title}
      </h2>
      {desc && (
        <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
          {desc}
        </p>
      )}
    </div>
  );
}